import { useStore as getStore } from "../../utils/useStore.js";
import inputsFactory from "./inputsFactory.js";

const initialState = () => ({
  fieldsInUse: {},
});

const [InputProvider, useInput, withInput] = getStore(
  inputsFactory,
  initialState,
  "Inputs"
);

export const inputsInitState = initialState();

export { useInput, InputProvider, withInput };

export default InputProvider;
